import { render } from "./cardArticlePeriple.component.vue?vue&type=template&id=405e7098"
import script from "./cardArticlePeriple.component.vue?vue&type=script&lang=js"
export * from "./cardArticlePeriple.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/periple/cards/cardArticlePeriple.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "405e7098"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('405e7098', __exports__)) {
    console.log('reload')
    api.reload('405e7098', __exports__)
  }
  
  module.hot.accept("./cardArticlePeriple.component.vue?vue&type=template&id=405e7098", () => {
    console.log('re-render')
    api.rerender('405e7098', render)
  })

}


export default __exports__